import { Smartphone } from 'lucide-react';
import { useDocumentTitle } from '@/lib/useDocumentTitle';
import logoUrl from '@/assets/logo.png';
import logoDarkUrl from '@/assets/logo-dark.png';

const TOKEN_PATTERN = /^[A-Za-z0-9_-]{40,100}$/;
const API_BASE = import.meta.env.VITE_API_BASE || 'https://dev.api.ampersandbrands.com';
const PRODUCTION = new URL(API_BASE).hostname === 'api.ampersandbrands.com';
const APP_PACKAGE = PRODUCTION
  ? 'com.ampersandbrands.sweetspot'
  : 'com.ampersandbrands.sweetspot.dev';
const APP_SCHEME = PRODUCTION ? 'sweetspot' : 'sweetspot-dev';
const APP_NAME = PRODUCTION ? 'The Sweet Spot' : 'Sweet Spot Dev';

function readEnrollmentToken(): string | null {
  const queryToken = new URLSearchParams(window.location.search).get('token');
  const hashToken = new URLSearchParams(window.location.hash.slice(1)).get('token');
  const token = queryToken ?? hashToken;

  return token && TOKEN_PATTERN.test(token) ? token : null;
}

function buildAppIntent(token: string): string {
  return `intent://kiosk-enroll?token=${encodeURIComponent(token)}#Intent;scheme=${APP_SCHEME};package=${APP_PACKAGE};end`;
}

export function KioskEnrollment() {
  useDocumentTitle();
  const token = readEnrollmentToken();

  return (
    <main className="flex min-h-screen items-center justify-center bg-candy-cream px-4 dark:bg-candy-dark-bg">
      <section className="w-full max-w-md rounded-lg border border-candy-line bg-candy-white p-8 text-center shadow-1 dark:border-candy-dark-line dark:bg-candy-dark-surface">
        <span className="mx-auto mb-4 flex w-fit items-center">
          <img src={logoUrl} alt="The Sweet Spot" className="h-24 w-auto dark:hidden" />
          <img src={logoDarkUrl} alt="" aria-hidden className="hidden h-20 w-auto dark:block" />
        </span>
        <h1 className="mb-3 text-2xl font-semibold text-candy-ink dark:text-candy-dark-ink">
          Set up this tablet
        </h1>
        {token ? (
          <>
            <p className="mb-6 text-sm text-candy-ink-muted dark:text-candy-dark-ink-muted">
              Continue in {APP_NAME} to finish store enrollment.
            </p>
            <a
              href={buildAppIntent(token)}
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-candy-pink px-4 py-3 text-sm font-medium text-white hover:opacity-90 dark:bg-candy-pink-dark dark:text-candy-dark-bg"
            >
              <Smartphone aria-hidden size={18} />
              Open {APP_NAME}
            </a>
          </>
        ) : (
          <p className="text-sm text-red-700 dark:text-red-300">
            This enrollment link is invalid or incomplete. Generate a new link in Cockpit.
          </p>
        )}
      </section>
    </main>
  );
}
